module.exports = __webpack_public_path__ + "img/p1_bg.07e58418.jpg";